import { FC } from 'react';
import { SVG, SVGComponentProps } from '../Template';

export const ShoppingCart01: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} viewBox="0 0 20 20" stroke="none">
      <path
        d="M1.66667 1.66667H2.75514C2.96015 1.66667 3.06266 1.66667 3.14515 1.70437C3.21785 1.73759 3.27945 1.79102 3.32262 1.85829C3.37161 1.93462 3.38611 2.0361 3.4151 2.23905L3.80952 5M3.80952 5L4.6861 11.4428C4.79734 12.2604 4.85296 12.6692 5.04842 12.977C5.22065 13.2481 5.46757 13.4637 5.75946 13.5978C6.09072 13.75 6.50329 13.75 7.32842 13.75H14.46C15.2455 13.75 15.6382 13.75 15.9591 13.6087C16.2421 13.4841 16.4849 13.2832 16.6602 13.0285C16.8591 12.7397 16.9326 12.3539 17.0796 11.5823L18.1826 5.79141C18.2343 5.51984 18.2602 5.38405 18.2227 5.27792C18.1898 5.18481 18.1249 5.1064 18.0396 5.05668C17.9424 5 17.8041 5 17.5277 5H3.80952ZM8.33333 17.5C8.33333 17.9602 7.96024 18.3333 7.5 18.3333C7.03976 18.3333 6.66667 17.9602 6.66667 17.5C6.66667 17.0398 7.03976 16.6667 7.5 16.6667C7.96024 16.6667 8.33333 17.0398 8.33333 17.5ZM15 17.5C15 17.9602 14.6269 18.3333 14.1667 18.3333C13.7064 18.3333 13.3333 17.9602 13.3333 17.5C13.3333 17.0398 13.7064 16.6667 14.1667 16.6667C14.6269 16.6667 15 17.0398 15 17.5Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
